import React from "react";
import "../Censor/CensorPage.css";
import { App, Space } from "antd";
import CensorSideMenu from "../../Components/Censor/CensorSideMenu/CensorSideMenu";
import CensorContent from "../../Components/Censor/CensorContent/CensorContent";
function CensorPage() {
  return (
    <div className="censor-dashboard-container">
      <div className="wrapper">
        {/* <CensorHeader/> */}
        <Space className="censorSideMenuAndContent">
          <CensorSideMenu />
          <CensorContent />
        </Space>
        {/* <CensorFooter/> */}
      </div>
    </div>
  );
}

export default CensorPage;
